import type { Hookable } from 'hookable'

import type { HarmonyPlanContextEvents } from '../useHarmonyPlanContext.events.schema'

type HarmonyPlanContextHookMap = {
  [K in keyof HarmonyPlanContextEvents]: (event: HarmonyPlanContextEvents[K]) => void | Promise<void>
}

/**
 * Handle for removing a previously registered harmony plan context hook.
 */
type HarmonyPlanContextUnsubscribe = () => void

interface HarmonyPlanContextLoggerLike {
  debug: (message: string, meta?: Record<string, unknown> | unknown) => void
}

interface UseHarmonyPlanContextOnPlanIdChangedParams {
  hooks: Hookable<HarmonyPlanContextHookMap>
  logger: HarmonyPlanContextLoggerLike
}

/**
 * Internal handler: debug hook for harmony plan route param changes.
 */
export default function useHarmonyPlanContextOnPlanIdChanged({
  hooks,
  logger,
}: UseHarmonyPlanContextOnPlanIdChangedParams) {
  const unsubscribe: HarmonyPlanContextUnsubscribe = hooks.hook(
    'PlanIdChanged',
    ({ harmonyPlanId, previousHarmonyPlanId, path }) => {
      logger.debug('Harmony plan route param changed', {
        path,
        previousHarmonyPlanId,
        harmonyPlanId,
      })
    },
  )

  return unsubscribe
}
